export enum LogisticVendorOrShipToEnum {
  vendor = 'vendor',
  shipTo = 'shipTo',
}
